import { useState } from "react";
import { Trash2 } from "lucide-react";
import { Loader } from "@/components/shared/loader";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useDeleteDocumentLibrary } from "@/features/documents/hooks/useDocumentLibrariesQueries";
import type { DocumentLibrary } from "@/types/document";

interface DeleteLibraryDialogProps {
  library: DocumentLibrary;
}

export function DeleteLibraryDialog({ library }: DeleteLibraryDialogProps) {
  const [open, setOpen] = useState(false);
  const del = useDeleteDocumentLibrary();

  async function onConfirm() {
    try {
      await del.mutateAsync(library.id);
      setOpen(false);
    } catch {
      /* mutation surfaces the error via onError */
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center justify-center text-muted-foreground hover:text-destructive transition-colors"
          aria-label="حذف المكتبة"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader className="text-right">
          <DialogTitle>حذف المكتبة</DialogTitle>
          <DialogDescription>
            هل أنت متأكد من حذف «{library.title}»؟ يجب أن تكون فارغة من المستندات.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2">
          <Button
            variant="outline"
            onClick={() => setOpen(false)}
            disabled={del.isPending}
          >
            إلغاء
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={del.isPending}
          >
            حذف
            {del.isPending && <Loader className="mr-2" />}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
